const COOKIE_KEY = 'nwp221';


// LOCAL
/*
const Api = {
  Url: 'http://localhost/milkproduct/api/',
  ImageUrl: 'http://localhost/milkproduct/api/public/uploads', // Dont put slash in last
  SiteUrl: 'http://localhost/milkproduct',
  version: 'v1/',
};
*/

const Api = {
  Url: 'https://vmp.peacesoft.in/api/',
  ImageUrl: 'https://vmp.peacesoft.in/api/public/uploads', // Dont put slash in last
  SiteUrl: 'http://localhost/vmp',
  version: 'v1/',
};


// ONLINE
/* const Api = {
  Url: 'https://milkproduct.peacesoft.in/api/',
  ImageUrl: 'https://milkproduct.peacesoft.in/api/public/uploads', // Dont put slash in last
  SiteUrl: 'https://milkproduct.peacesoft.in',
  version: 'v1/',
}; */


const Var = {
  Title: 'Billing',
  Site: '',
  Phone: '9487900120',
  Email: '',
  Address: '',
  City: 'Tirunelveli',
  Pincode: ' 627002',
  RegularCourseFeeForScSt: 0,
  RegularCourseFeeForOthers: 50,
  SelfCourseFeeForScSt: 50,
  SelfCourseFeeForOthers: 50,
  EnableCashPayment: true,
  EnableOnlinePayment: true,
};

export {
  COOKIE_KEY,
  Api,
  Var,
};
